import { render, staticRenderFns } from "./ProductInfoItemSoftware.vue?vue&type=template&id=331390e8&"
import script from "./ProductInfoItemSoftware.vue?vue&type=script&lang=js&"
export * from "./ProductInfoItemSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports